import { styled } from '@mui/material'
import Box from '@mui/material/Box'

export const RootStyle = styled('div')(({ theme }) => ({
   width: '13.875rem',
   height: '9rem',
   margin: '0 auto',
   display: 'flex',
   padding: theme.spacing(1),
   border: `1px dashed ${theme.palette.grey[500_32]}`,
}))

export const DropZoneStyle = styled('div')(({ theme }) => ({
   width: '100%',
   '&:hover': {
      cursor: 'pointer',
      opacity: 0.72,
   },
   transition: theme.transitions.create('opacity', {
      easing: theme.transitions.easing.easeInOut,
      duration: theme.transitions.duration.shorter,
   }),
}))

export const StyledImage = styled('img')({
   display: 'flex',
   height: '100%',
   width: '100%',
   justifyContent: 'center',
   alignItems: 'center',
   alignContent: 'center',
   position: 'relative',
   bottom: 99,
   zIndex: -1,
})

export const PlaceholderStyle = styled(Box)(({ theme }) => ({
   height: '100%',
   width: '100%',
   position: 'relative',
   opacity: 0,
   color: theme.palette.text.secondary,
   backgroundColor: theme.palette.background.neutral,
   transition: theme.transitions.create('opacity', {
      easing: theme.transitions.easing.easeInOut,
      duration: theme.transitions.duration.shorter,
   }),
   '&:hover': { opacity: 0.72 },
}))
export const StyledInput = styled('input')({
   height: '100%',
   width: '100%',
   cursor: 'pointer',
   opacity: 0,
})
